// register ScrollTrigger
gsap.registerPlugin(ScrollTrigger,SplitText);

window.addEventListener('load', () => {

    // gallery

    // 2) Create a matchMedia context
    const mm = gsap.matchMedia();

    mm.add(
        {
            isDesktop: "(min-width: 768px)",  // desktop if ≥ 768px
            isMobile:  "(max-width: 767px)"   // mobile if ≤ 767px
        },
        (context) => {
            const { isDesktop, isMobile } = context.conditions;
            const galleryEl = document.querySelector('.lucy-gallery');
            if (!galleryEl) {
                console.warn("No .lucy-gallery found on this page—skipping GSAP.");
                return;
            }

            let tl; // timeline reference

            if (isDesktop) {
                console.log("→ GSAP Desktop branch");

                // ─── Desktop: Animate in “pairs” ─────────────────────────
                const pairs      = ['pair1', 'pair2', 'pair3']; // adjust if you have more/less
                const xLeft      = ['-25vw', '-30vw', '-24vw'];
                const xRight     = ['25vw',  '30vw',  '24vw'];
                const leftScale  = [1.4, 1.3, 1.2];
                const rightScale = [1.2, 1.25, 1.3];

                const stageDur  = 1;      // 1 s per “fly-in”
                const crossDur  = 0.2;    // 0.2 s overlap fade-out
                const increment = stageDur - crossDur; // 0.8 s between each stage start
                const flyDur    = 0.8;    // how long each image takes to fly in

                // Compute EXACT pixels to pin: 1 viewport per pair
                const pinEndPixels = pairs.length * window.innerHeight;
                console.log(
                    `Desktop: found ${pairs.length} pairs, pin for ${pinEndPixels}px.`
                );

                tl = gsap.timeline({
                    defaults: { ease: "power2.out" },
                    scrollTrigger: {
                        trigger: galleryEl,
                        start:   "top top",
                        end:     pinEndPixels, // numeric value = that many pixels below “top”
                        scrub:   1,
                        pin:     true,
                        //    markers: true  // ← uncomment to see red/green markers
                    }
                });

                pairs.forEach((p, i) => {
                    const t0 = i * increment;

                    // 1) Fly in left image from left
                    tl.to(`.${p}.img-left`, {
                        x:       xLeft[i],
                        scale:   leftScale[i],
                        opacity: 1,
                        duration: flyDur
                    }, t0);

                    // 2) Fly in right image from right (0.2s later)
                    tl.to(`.${p}.img-right`, {
                        x:       xRight[i],
                        scale:   rightScale[i],
                        opacity: 1,
                        duration: flyDur
                    }, t0 + 0.2);

                    // 3) Fade out the entire pair before moving to the next
                    if (i < pairs.length - 1) {
                        tl.to(`.${p}`, {
                            opacity: 0,
                            duration: crossDur
                        }, t0 + increment);
                    }
                });

            } else if (isMobile) {
                console.log("→ GSAP Mobile branch");

                // ─── Mobile: Animate each image (left+right) one at a time ──
                const allImages = Array.from(
                    galleryEl.querySelectorAll('.img-left, .img-right')
                );
                console.log(`Mobile: found ${allImages.length} total images.`);

                const stageDur  = 1;      // 1 s per image fly-in
                const crossDur  = 0.2;    // 0.2 s fade-out overlap
                const increment = stageDur - crossDur; // 0.8 s between each image start
                const flyDur    = 0.8;    // how long each image takes to appear

                // Compute EXACT pixels to pin: 1 viewport per image
                const pinEndPixels = pairs.length * window.innerHeight;

                console.log(
                    `Mobile: pin for ${pinEndPixels}px (=${allImages.length} × ${window.innerHeight}px).`
                );

                tl = gsap.timeline({
                    defaults: { ease: "power2.out" },
                    scrollTrigger: {
                        trigger: galleryEl,
                        start:   "top top",
                        end:     pinEndPixels, // numeric pixel count
                        scrub:   1,
                        pin:     true,
                        //    markers: true  // ← uncomment to debug if something’s too short
                    }
                });

                allImages.forEach((imgEl, idx) => {
                    const t0 = idx * increment;

                    // 1) Fade in / center this image
                    tl.to(imgEl, {
                        x:        0,      // force x=0 so it stays centered in flex
                        scale:    1,
                        opacity:  1,
                        duration: flyDur,
                        transformOrigin: "center center"
                    }, t0);

                    // Fade out before next image, EXCEPT for the last two images
                    if (idx < allImages.length - 2) {
                        tl.to(imgEl, {
                            opacity: 0,
                            duration: crossDur
                        }, t0 + increment);
                    }
                });
            }

            // 3) Return a cleanup function for matchMedia
            return () => {
                if (tl?.scrollTrigger) tl.scrollTrigger.kill();
                tl?.kill();
            };
        }
    );


    const panels = gsap.utils.toArray('.panel');

// only proceed if at least one panel exists
    if (panels.length) {
        // optional defaults (remove markers in prod)
        ScrollTrigger.defaults({
            toggleActions: "play none none reverse",
            //    markers: true
        });

        // pin & snap each panel
        panels.forEach(panel => {
            ScrollTrigger.create({
                trigger: panel,
                start: "top top",
                end: "+=100%",
                pin: true,
                pinSpacing: false,
                scrub: 1,
                snap: {
                    snapTo: 1,
                    duration: { min: 0.5, max: 0.5 }
                }
            });
        });
    }


    /* Typing text animation START */
    const lucyHeadlines = document.querySelectorAll(".lucy-type-text .elementor-heading-title");

    if (lucyHeadlines.length > 0) {
        lucyHeadlines.forEach(headline => {
            const split = new SplitText(headline, { type: "chars", charsClass: "char", tag: "span" });

            // tween is paused; we'll feed it progress manually
            const tween = gsap.from(split.chars, {
                opacity: 0,
                y: 10,
                ease: "none",
                stagger: { each: 0.08 },
                paused: true
            });

            let maxP = 0; // tracks the furthest progress reached

            ScrollTrigger.create({
                trigger: headline,
                start: "top 80%",
                end: "top 20%",        // length of the “typing” scrub
                onUpdate(self) {
                    if (self.progress > maxP) {
                        maxP = self.progress;
                        tween.progress(maxP); // forward-only progress
                    }
                },
                onLeave(self) {         // finished once → lock it in
                    tween.progress(1);
                    self.kill(false);     // keep end state, remove trigger
                },
                onLeaveBack(self) {     // if user scrolls above start later, don’t rewind
                    self.kill(false);
                }
            });
        });
    }

    /* Typing text animation END */


    /* words-sliding-down animation START */
    const fallingHeadings = document.querySelectorAll(".words-sliding-down .elementor-heading-title");

    if (fallingHeadings.length > 0) {
        fallingHeadings.forEach(el => {
            // split into words
            const split = new SplitText(el, {
                type: "words",
                wordsClass: "word",
                tag: "span"
            });

            // animate each word falling down on scroll
            gsap.from(split.words, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    toggleActions: "play none none none"
                },
                y: -40,
                opacity: 0,
                duration: 0.6,
                ease: "power4.out",
                stagger: 0.1
            });
        });
    }

    /* words-sliding-down animation END */


    /* words-sliding-up animation START */
    const upheadings = document.querySelectorAll(".words-sliding-up .elementor-heading-title");
    if (upheadings.length > 0) {
        upheadings.forEach(el => {
            const split = new SplitText(el, {
                type: "words",
                wordsClass: "word",
                tag: "span"
            });

            gsap.set(split.words, {
                y: 40,
                autoAlpha: 0,
                display: "inline-block"
            });

            gsap.to(split.words, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    toggleActions: "play none none none"
                },
                y: 0,
                autoAlpha: 1,
                duration: 0.6,
                ease: "power4.out",
                stagger: 0.3
            });
        });
    }

    /* words-sliding-up animation END */

    /* Letters-sliding-right animation START*/
    const slideInEls = document.querySelectorAll(".slide-in-letters .elementor-heading-title");

    if (slideInEls.length > 0) {
        slideInEls.forEach(el => {
            // split into individual characters wrapped in spans
            const split = new SplitText(el, {
                type: "chars",
                charsClass: "char",
                tag: "span"
            });

            split.chars.forEach(char => {
                const wrapper = document.createElement("span");
                wrapper.classList.add("overflow-hidden");
                char.parentNode.insertBefore(wrapper, char);
                wrapper.appendChild(char);
            });

            gsap.set(split.chars, {
                x: 60,
                visibility: "visible"
            });

            gsap.to(split.chars, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    toggleActions: "play none none none"
                },
                x: 0,
                duration: 1,
                ease: "power3.out"
            });
        });
    }

    /* Letters-sliding-right animation END*/
    /* text changing color animation START */
    gsap.utils.toArray('.text-changes-color .elementor-heading-title').forEach(el => {
        // avoid double-initializing if something calls this twice
        if (el._splitInitialized) return;
        el._splitInitialized = true;

        // hide → split → show
        gsap.set(el, { visibility: 'hidden' });
        const split = new SplitText(el, { type: 'words', tag: 'span' });
        gsap.set(el, { visibility: 'visible' });

        // separate <strong> words vs. the rest
        const allWords    = split.words;
        const strongWords = allWords.filter(w => w.closest('strong'));
        const normalWords = allWords.filter(w => !w.closest('strong'));

        // pick up your real CSS end-colors at runtime
        const normalEnd = getComputedStyle(el).color;
        const strongEnd = strongWords.length
            ? getComputedStyle(strongWords[0]).color
            : normalEnd;

        // build one ScrollTrigger timeline per heading
        gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: () =>
                    window.innerWidth <= 768 ? 'top 60%' : 'top 84%',
                end: () =>
                    window.innerWidth <= 768 ? 'bottom 20%' : '+=50%',
                scrub: 0.75,
                invalidateOnRefresh: true
            }
        })
            // normal words: from gray → CSS color
            .fromTo(
                normalWords,
                { color: '#D7CCB8' },
                { color: normalEnd, duration: 0.1, stagger: 0.03, ease: 'none' }
            )
            // strong words: from gray → strong CSS color (runs in parallel)
            .fromTo(
                strongWords,
                { color: '#D7CCB8' },
                { color: strongEnd, duration: 0.1, stagger: 0.03, ease: 'none' },
                0
            );
    });
    /* text changing color animation END */


    const headings = gsap.utils.toArray(
        ".text-changes-color2 .elementor-heading-title"
    );

    if (headings.length > 0) {
        console.log("🖋️ text-change headings found:", headings.length);

        headings.forEach(el => {
            if (el._splitInitialized) return; // skip if we already ran on this one
            el._splitInitialized = true;

            gsap.set(el, { visibility: "hidden" });
            const split = new SplitText(el, { type: "words", tag: "span" });
            gsap.set(el, { visibility: "visible" });

            const allWords    = split.words;
            const strongWords = allWords.filter(w => w.closest("strong"));
            const normalWords = allWords.filter(w => !w.closest("strong"));

            const normalEnd = getComputedStyle(el).color;
            const strongEnd = strongWords.length
                ? getComputedStyle(strongWords[0]).color
                : normalEnd;

            gsap
                .timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: () =>
                            window.innerWidth <= 768 ? "top 60%" : "top 84%",
                        end: () =>
                            window.innerWidth <= 768 ? "bottom 20%" : "+=50%",
                        scrub: 0.75,
                        invalidateOnRefresh: true,
                    },
                })
                .fromTo(
                    normalWords,
                    { color: "#D7CCB8" },
                    {
                        color: normalEnd,
                        duration: 0.1,
                        stagger: 0.03,
                        ease: "none",
                    }
                )
                .fromTo(
                    strongWords,
                    { color: "#D7CCB8" },
                    {
                        color: strongEnd,
                        duration: 0.1,
                        stagger: 0.03,
                        ease: "none",
                    },
                    0
                );
        });

        ScrollTrigger.refresh();
    }

    // Animate progress-circle only if it exists
    const progressPath = document.querySelector('.progress-circle path');
    if (progressPath) {
        gsap.fromTo(progressPath, {
            drawSVG: 0
        }, {
            drawSVG: "100%",
            scrollTrigger: {
                start: 0,
                end: "max",
                scrub: true
            }
        });
    }

    // Animate .back-to-top only if it exists
    const backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
        gsap.fromTo(backToTop, {
            yPercent: 100,
            autoAlpha: 0
        }, {
            yPercent: 0,
            autoAlpha: 1,
            scrollTrigger: {
                start: 5,
                toggleActions: "play none none reverse"
            }
        });
    }

});



document.addEventListener('DOMContentLoaded', () => {
    if (!window.gsap) { console.warn('GSAP not found.'); return; }

    // ---------- LETTER DRAW ----------
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let lettersStarted = false;

    function startLetterDraw(delayMs = 0) {
        if (lettersStarted) return;
        lettersStarted = true;

        const run = () => {
            const letters = [];
            [1, 2, 3, 4].forEach(i => {
                const path = document.querySelector(`#Letter0${i} path`);
                if (path) letters.push(path);
            });
            if (!letters.length) return;

            if (REDUCED) {
                letters.forEach(path => { path.style.fill = '#3B2A1A'; path.style.stroke = 'none'; });
                return;
            }

            letters.forEach(path => {
                const L = path.getTotalLength();
                path.style.fill             = 'none';
                path.style.stroke           = '#3B2A1A';
                path.style.strokeWidth      = '0.1';
                path.style.strokeDasharray  = L;
                path.style.strokeDashoffset = L;
            });

            const tl = gsap.timeline({ defaults: { duration: 0.35, ease: 'power1.inOut' } });
            letters.forEach(path => {
                tl.to(path, { strokeDashoffset: 0 });
                tl.to(path, { fill: '#3B2A1A' }, '<');
            });
        };

        delayMs > 0 ? setTimeout(run, delayMs) : run();
    }

    // ---------- PRELOADER (optional) ----------
    const preloader = document.getElementById('custom-preloader');

    if (!preloader) {
        // No preloader → start immediately
        startLetterDraw(0);
        return;
    }

    // With preloader → lock scroll
    document.body.classList.add('preloader-active');
    document.body.style.overflow = 'hidden';

    const bgColors = ["#3B2A1A","#BB5C30","#8A982B","#9D8A6D","#FCF1E2","#DBD4C9","#BACD34","#F4F2F0","#FFFFFF"];
    const contrastColors = ["#FFFFFF","#FCF1E2","#3B2A1A","#8A982B","#BB5C30","#9D8A6D","#3B2A1A","#BACD34","#BB5C30"];

    const bg         = preloader.querySelector('.preloader-bg');
    const allCircles = preloader.querySelectorAll('.circle');
    const mainCircle = preloader.querySelector('.circle.main');
    const circles    = [...allCircles].filter(el => !el.classList.contains('main'));

    let loopCount = 0;
    const loops = 3;

    const spreadFactors = [0.4, 0.65, 1.0];
    const scaleFactors  = [1.5, 2.2, 3.3];

    const centerArea = 200;
    const randCenterOffset = () => (Math.random() - 0.5) * centerArea;

    function finishPreloader() {
        gsap.to(preloader, {
            autoAlpha: 0,
            duration: 0.6,
            onComplete: () => {
                preloader.style.display = 'none';
                document.body.classList.remove('preloader-active');
                document.body.style.overflow = '';
                // If for any reason letters didn't start yet, start now (no extra delay)
                startLetterDraw(0);
            }
        });
    }

    function animateLoop() {
        const bgIdx = loopCount % bgColors.length;
        const circleColor = contrastColors[bgIdx % contrastColors.length];

        bg.classList.remove('hole-mode');
        gsap.to(bg, { backgroundColor: bgColors[bgIdx], duration: 0.6, ease: 'power2.inOut' });

        const spreadX = window.innerWidth  * spreadFactors[loopCount];
        const spreadY = window.innerHeight * spreadFactors[loopCount];
        const maxScale = scaleFactors[loopCount];

        gsap.set(mainCircle, { x:0, y:0, scale:0.12, opacity:0.4, backgroundColor: circleColor });
        if (loopCount < loops - 1) {
            const coverScale = Math.max(window.innerWidth, window.innerHeight) / 35;
            gsap.to(mainCircle, { scale: coverScale, opacity: 0, duration: 1.0, ease: 'power1.in' });
        } else {
            gsap.to(mainCircle, { opacity: 0, duration: 0.1 });
        }

        circles.forEach(circle => {
            const x0 = randCenterOffset();
            const y0 = randCenterOffset();
            const angle = Math.random() * Math.PI * 2;
            const xSpread = Math.cos(angle) * (spreadX * (0.25 + Math.random() * 0.4));
            const ySpread = Math.sin(angle) * (spreadY * (0.25 + Math.random() * 0.4));

            gsap.set(circle, {
                x: x0,
                y: y0,
                scale: 0.12 + Math.random() * 0.06,
                opacity: 1,
                backgroundColor: circleColor
            });

            gsap.timeline()
                .to(circle, {
                    x: x0 + xSpread,
                    y: y0 + ySpread,
                    scale: maxScale * (0.85 + Math.random() * 0.25),
                    duration: 0.7,
                    ease: 'power2.out'
                })
                .to(circle, {
                    scale: 0.1,
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in'
                });
        });

        if (loopCount === loops - 1) {
            bg.style.setProperty('--r', '0px');
            bg.classList.add('hole-mode');

            // Start the hole expansion
            const HOLE_TRIGGER_PROGRESS = 0.18; // ≈ when content is visible enough
            const EXTRA_DELAY_MS = 80;          // tiny cushion

            setTimeout(() => {
                const rMax = 150 * Math.max(window.innerWidth, window.innerHeight) / 100; // ≈150vw in px
                gsap.to(bg, {
                    duration: 1.1,
                    ease: 'power1.inOut',
                    onUpdate() {
                        const p = this.progress();
                        bg.style.setProperty('--r', (p * rMax) + 'px');

                        // ⏱️ Trigger letters DURING reveal, not after fade
                        if (!lettersStarted && p >= HOLE_TRIGGER_PROGRESS) {
                            startLetterDraw(EXTRA_DELAY_MS);
                        }
                    },
                    onComplete: finishPreloader
                });
            }, 200); // small lead-in before the hole reveal begins
        }

        loopCount++;
        if (loopCount < loops) setTimeout(animateLoop, 1400);
    }

    animateLoop();
});